import { JSX } from 'react';

import {
    DisposableCupDefault,
    DisposableCupSelected,
    HotDefault,
    HotSelected,
    IceDefault,
    IceSelected,
    ReusableCupDefault,
    ReusableCupSelected,
    TumblerDefault,
    TumblerSelected,
} from '../icons';

export type AvailableOptionName = 'HOT' | 'ICE' | '머그컵' | '일회용컵' | '텀블러' | 'Only ICE' | 'Only HOT';

interface OptionIcon {
    DefaultIcon: () => JSX.Element;
    SelectedIcon: () => JSX.Element;
}

export const optionsIcons : Record<AvailableOptionName, OptionIcon> = {
    HOT: {
        DefaultIcon: HotDefault,
        SelectedIcon: HotSelected,
    },
    ICE: {
        DefaultIcon: IceDefault,
        SelectedIcon: IceSelected,
    },
    머그컵: {
        DefaultIcon: ReusableCupDefault,
        SelectedIcon: ReusableCupSelected,
    },
    일회용컵: {
        DefaultIcon: DisposableCupDefault,
        SelectedIcon: DisposableCupSelected,
    },
    텀블러: {
        DefaultIcon: TumblerDefault,
        SelectedIcon: TumblerSelected,
    },
    'Only HOT': {
        DefaultIcon: HotDefault,
        SelectedIcon: HotSelected,
    },
    'Only ICE': {
        DefaultIcon: IceDefault,
        SelectedIcon: IceSelected,
    },
};
